import React from 'react';
import { styled } from '@compiled/react';
import { SimpleTag } from '@atlaskit/tag';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../../common/messages.tsx';
import { ReadViewContainer } from '../../common/ui/styled.tsx';

export const SelectReadView = ({
	value,
	showPlaceholderIfEmpty = true,
}: {
	value: string[];
	showPlaceholderIfEmpty?: boolean;
}) => {
	const { formatMessage } = useIntl();
	const hasValue = value.length > 0;
	const placeholderText = showPlaceholderIfEmpty
		? formatMessage(messages.placeholderNoneSelected)
		: null;
	return (
		<ReadViewContainer isPlaceholder={!hasValue}>
			{hasValue ? (
				value.map((val) => (
					<Wrapper key={val}>
						<SimpleTag text={val} />
					</Wrapper>
				))
			) : (
				<PlaceholderSpacer>{placeholderText}</PlaceholderSpacer>
			)}
		</ReadViewContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	marginLeft: token('space.negative.050'),
	marginRight: token('space.050'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PlaceholderSpacer = styled.div({
	paddingTop: token('space.050'),
	paddingRight: 0,
	paddingBottom: token('space.050'),
	paddingLeft: 0,
});
